
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class BillingInfoDtoModel extends Model<BillingInfoDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'billingInfoDto.property.companyId' },
		{ name: 'contactId', type: 'guid', languageString: 'billingInfoDto.property.contactId' },
		{ name: 'companyName', type: 'string', languageString: 'billingInfoDto.property.companyName' },
		{ name: 'streetAddress', type: 'string', languageString: 'billingInfoDto.property.streetAddress' },
		{ name: 'city', type: 'string', languageString: 'billingInfoDto.property.city' },
		{ name: 'zipcode', type: 'string', languageString: 'billingInfoDto.property.zipcode' },
		{ name: 'vatNumber', type: 'string', languageString: 'billingInfoDto.property.vatNumber' },
		{ name: 'glnNumber', type: 'string', languageString: 'billingInfoDto.property.glnNumber' },
		{ name: 'country', type: 'string', languageString: 'billingInfoDto.property.country' },
		{ name: 'contactFirstName', type: 'string', languageString: 'billingInfoDto.property.contactFirstName' },
		{ name: 'contactLastName', type: 'string', languageString: 'billingInfoDto.property.contactLastName' },
		{ name: 'emailAddress', type: 'string', languageString: 'billingInfoDto.property.emailAddress' },
		{ name: 'phoneNumber', type: 'string', languageString: 'billingInfoDto.property.phoneNumber' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public contactId?: string;
	public companyName: string;
	public streetAddress: string;
	public city: string;
	public zipcode: string;
	public vatNumber: string;
	public glnNumber: string;
	public country: string;
	public contactFirstName: string;
	public contactLastName: string;
	public emailAddress: string;
	public phoneNumber: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.contactId = undefined;
		this.companyName = '';
		this.streetAddress = '';
		this.city = '';
		this.zipcode = '';
		this.vatNumber = '';
		this.glnNumber = '';
		this.country = '';
		this.contactFirstName = '';
		this.contactLastName = '';
		this.emailAddress = '';
		this.phoneNumber = '';
		
	}
	getProperties(){
		return BillingInfoDtoModel.classProperties;
	}
}

